<template>
  <section class="container-fluid py-6 py-md-7">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="mb-5">Representative Transactions</h2>
      </div>
      <div class="col-12 col-md-3 col-xl-2 offset-xl-1 link-container">
        <h4
          :class="[activeLink == 0 ? active : '', 'group-link']"
          @click="shuffleCards(0)"
        >
          Mergers &amp; Acquisitions
        </h4>
        <h4
          :class="[activeLink == 2 ? active : '', 'group-link']"
          @click="shuffleCards(4)"
        >
          Capital Raising
        </h4>
         <h4
          :class="[activeLink == 1 ? active : '', 'group-link']"
          @click="shuffleCards(2)"
        >
          Strategic Advisory
        </h4>
      </div>
      <div class="col-12 col-md-9 col-xl-7 offset-xl-1">
        <TransactionCardRow enableDarkMode ref="cards" stopTimer />
      </div>
      <div class="col-12 text-center mt-6">
        <router-link class="btn" :to="{ name: 'Transactions' }"
          >View More Transactions</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import TransactionCardRow from "@/components/TransactionCardRow.vue";
export default {
  components: {
    TransactionCardRow
  },
  data() {
    return {
      activeLink: 0,
      active: "active-link"
    };
  },
  methods: {
    shuffleCards(target) {
      this.$refs.cards.setNewCards(target);
      this.activeLink = target / 2;
    }
  }
};
</script>

<style lang="scss" scoped>
h2,
p {
  color:  #111d3c;
}
.link-container {
  border-right: 1px solid rgba(100, 100, 100, 0.2);
  @media screen and (max-width: 768px) {
    display: flex;
    max-width: 100%;
    justify-content: space-around;
    overflow: hidden;
    overflow-x: scroll;
  }
}
.group-link {
  color: #111d3c;
  font-size: 1.75rem;
  line-height: 2.25rem;
  margin-bottom: 2rem;
  cursor: pointer;
  opacity: 0.75;
  transition: all 0.3s ease;
  &:hover {
    color: #dcb249;
  }
  &.active-link {
    color: #dcb249;
    opacity: 1;
  }
  @media screen and (max-width: 768px) {
    font-family: europa, sans-serif;
    font-weight: 400;
    text-decoration: underline;
    font-size: 1rem;
    text-transform: uppercase;
  }
}
hr {
  max-width: 300px;
  margin-left: 0;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
</style>
